export default class TextFieldConfiguration {
  constructor({ fieldName = 'value', key, label, type = 'text', rules = [] }) {
    this.fieldName = fieldName;
    this.key = key || fieldName;
    this.label = label;
    this.type = type;
    this.rules = rules;
  }
}
